import { PlatformAppsApiClient } from '@fourthwall/services/dist/PlatformAppsApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useInstalledPlatformAppsQuery = createQueryHook(
  PlatformAppsApiClient.getPlatformApps,
  {
    queryKey: ['installedPlatformApps'],
  },
)
